import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { dateParams } from "@/lib/format";
import { Loader2 } from "lucide-react";
import { CuttingStats } from "@/components/cutting/CuttingStats";
import { CuttingQueue } from "@/components/cutting/CuttingQueue";
import { CuttingLogs } from "@/components/cutting/CuttingLogs";

export const CuttingTab = ({ range }) => {
  const params = dateParams(range);
  const { data: stats, isLoading } = useQuery({ queryKey: ["cutting", "stats", params], queryFn: async () => (await api.get("/cutting/stats", { params })).data });
  const { data: logs = [] } = useQuery({ queryKey: ["cutting", "logs", params], queryFn: async () => (await api.get("/cutting/logs", { params })).data });
  return (
    <div className="space-y-6" data-testid="cutting-tab">
      {isLoading || !stats ? <Loader2 className="h-6 w-6 animate-spin text-primary" /> : <CuttingStats s={stats} />}
      <CuttingQueue />
      <CuttingLogs logs={logs} />
    </div>
  );
};
